import {
  DeliveryServiceMapName,
  DeliveryServiceName,
  deliveryServiceNameMap,
} from '@/domain/models/DeliveryService/DeliveryService';
import { DeliveryStore } from '@/services/StoreManagement/MasterStores/hooks/serachList/useStoreManagementMasterStoreSearchList';

const name = {
  key: 'name',
  label: '店舗名',
  question: 'デリバリーサービス出店名',
} as const;
const authStoreName = {
  key: 'authStoreName',
  label: '拠点名',
  question: '住所のある実店舗名',
} as const;
const associatebrandName = {
  key: 'associatebrandName',
  label: 'ブランド名',
  question: '出店するデリバリーサービスのブランド名',
} as const;
const camelOrderAlignment = {
  key: 'camelOrderAlignment',
  label: 'CamelOrder連携状況',
  question: undefined,
} as const;
const uberEatsAlignment = {
  key: 'uberEatsAlignment',
  label: 'UberEats連携状況',
  question: undefined,
} as const;
const menuAlignment = {
  key: 'menuAlignment',
  label: 'menu連携状況',
  question: undefined,
} as const;
const demaecanAlignment = {
  key: 'demaecanAlignment',
  label: '出前館連携状況',
  question: undefined,
} as const;
const businessNumber = {
  key: 'business_number',
  label: 'インボイス事業者 登録番号',
  question: undefined,
} as const;

const businessName = {
  key: 'businessName',
  label: 'インボイス事業者 表示用企業名称',
  question: 'インボイス事業者 表示用企業名称',
} as const;

export const masterStoreForm = {
  name,
  authStoreName,
  associatebrandName,
  businessNumber,
  businessName,
} as const;

const tableColumns = [
  { ...name, width: '200px' },
  { ...authStoreName, width: '200px' },
  { ...associatebrandName, width: '200px' },
  { ...camelOrderAlignment, width: '150px' },
  { ...uberEatsAlignment, width: '150px' },
  { ...menuAlignment, width: '150px' },
  { ...demaecanAlignment, width: '150px' },
] as const;

export const masterStoreTableThs = tableColumns.map((tableColumn) => {
  return {
    label: tableColumn.label,
    minWidth: tableColumn.width,
    question: tableColumn.question,
  };
});

type RecordDeliveryServiceName = Record<DeliveryServiceName, unknown>;
export type ConnectDeliveryService = keyof Pick<
  RecordDeliveryServiceName,
  'Uber Eats' | 'menu' | 'Demaecan' | 'CamelOrder' | 'CamelCall'
>;

/**
 * @warning 注意：masterStoreTableThsと順番は合わせないといけないので注意
 **/
export const CONNECT_DELIVERY_SERVICES: ConnectDeliveryService[] = [
  'CamelOrder',
  'Uber Eats',
  'menu',
  'Demaecan',
];

export const noRequest = 0;
export const nowRequest = 1;
const linked = 2;
const canceled = 3;

export const integrationStatusMap = {
  [noRequest]: '未申請',
  [nowRequest]: '申請中',
  [linked]: '連携済',
  [canceled]: '解約済',
} as const;

export const integrationStatusColor = {
  [noRequest]: 'blackAlpha',
  [nowRequest]: 'yellow',
  [linked]: 'blue',
  [canceled]: 'red',
} as const;

export type IntegrationStatusNum = keyof typeof integrationStatusMap;
export type IntegrationStatus = Util.ValueOf<typeof integrationStatusMap>;

export const deliveryStoreIntegrationStatus = (
  deliveryStores: DeliveryStore[],
  deliveryService: ConnectDeliveryService
): IntegrationStatus | '-' => {
  const findedDeliveryStore = deliveryStores.find(
    (ds) => ds.delivery_service_name === deliveryService
  );
  if (findedDeliveryStore === undefined) return '-';
  return integrationStatusMap[findedDeliveryStore.integration_status];
};

export type TargetSidebar = 'new' | 'edit';

export type DeliveryServiceDisplayName = keyof Pick<
  Record<DeliveryServiceMapName, unknown>,
  'CamelOrder' | 'Uber Eats' | 'menu' | '出前館' | 'CamelCall'
>;

export type IntegrationDeliveryServiceName = Util.ValueOf<
  Pick<
    typeof deliveryServiceNameMap,
    'CamelOrder' | 'Uber Eats' | 'menu' | 'Demaecan' | 'CamelCall'
  >
>;
